var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","rounded":"","dark":"","outlined":"","href":"https://forms.gle/BVhK9WWjYSNwDU3p8","target":"_blank"}},[_vm._v("Sign up now")])}
var staticRenderFns = []

export { render, staticRenderFns }